<template>
  <v-container fluid class="deferral">
    <!--BEGIN Add warning alert-->
    <v-dialog
      persistent
      v-model="defermentFeeDialogBox"
      max-width="50%"
      height="70vh"
      class="exemptions"
      :fullscreen="$vuetify.breakpoint.mobile"
    >
      <v-card>
        <v-card-text class="summary deferral">
          <h3 class="pa-2 ma-3 text-center">DEFERMENT OF EXAMINATION FEES</h3>
          <p class="">
            A student will be allowed to defer examination fees to the
            subsequent examination sitting only once in any particular part upon
            application and providing sufficient reason(s) for deferment.
          </p>
          <p>
            The successful applicant shall be required to pay an administrative
            charge equivalent to 15% of the applicable examination fees thirty
            (30) days prior to the examination period, failure to which the
            opportunity granted for deferment will lapse.
          </p>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="closeDefermentFeeDialog"
            >I Understand</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--END Add warning alert-->
    <v-card flat>
      <v-card-title>
        <v-btn
          text
          @click="$router.back()"
          class="mt-md-3 custom-class mb-sm-3"
        >
          <v-icon left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="deferralForm" v-model="isValid">
          <v-row>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                label="Student Number"
                v-model="formData.studentNo"
                readonly
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                label="Programme"
                v-model="formData.programme"
                readonly
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                label="Profile ID"
                v-model="formData.profileID"
                readonly
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="3" sm="6">
              <v-text-field
                label="Stage"
                v-model="formData.stage"
                readonly
                outlined
                dense
              />
            </v-col>
          </v-row>
        </v-form>
        <div class="deferredUnits" v-if="!isEdit">
          <v-data-table
            :headers="headers"
            :items="bookedUnits"
            :items-per-page="5"
            class="elevation-0"
            item-key="reg_no"
          >
            <template v-slot:[`item.ID`]="{ index }">
              <span>{{ index + 1 }}</span>
            </template>
          </v-data-table>
        </div>
        <div class="deferralLines" v-else-if="isReadonly || isEdit">
          <v-data-table
            :headers="headersLines"
            :items="formData.examDeferralLines"
            :items-per-page="5"
            class="elevation-0"
            item-key="reg_no"
          >
            <template v-slot:[`item.amount`]="{ item }">
              <span>{{ item.amount | currencyFormat }}</span>
            </template>
          </v-data-table>
        </div>
        <div class="upload-attachments">
          <div class="attachment--documents">
            <v-chip-group
              active-class="orange darken-2"
              column
              multiple
              class="mx-2"
            >
              <v-chip
                v-for="(item, i) in attachments"
                :key="i"
                color="primary"
                outlined
                label
                :disabled="isReadonly"
              >
                <v-btn
                  left
                  color="primary"
                  class="text-capitalize"
                  text
                  @click="editAttachment(item, i)"
                  :disabled="isReadonly"
                >
                  {{ item.fileName }}
                </v-btn>
                <v-divider vertical></v-divider>
                <v-tooltip bottom>
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn
                      class="py-2 ml-4"
                      icon
                      :disabled="isReadonly"
                      right
                      v-on="on"
                      v-bind="attrs"
                      color="deep-orange"
                      @click="removeAttachment(i, item)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Remove Attachment</span>
                </v-tooltip>
              </v-chip>
            </v-chip-group>
            <div class="d-flex justify-center flex-column">
              <div
                :class="
                  attachments.length !== 0
                    ? 'align-self-center mt-3'
                    : 'align-self-center'
                "
              >
                <deferral-attachment
                  :isEdit="isEdit"
                  :BtnCaption="BtnCaption"
                  @addAttachment="addAttachment"
                  :isReadonly="isReadonly"
                  :data="displayAttachment"
                />
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          @click="isEdit ? UpdateDeferral() : requestForDeferral()"
        >
          {{
            isEdit ? "Update Deferral Application" : "Request For Deferral"
          }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import DeferralAttachment from "@/packages/exams/modules/Deferrals/components/DeferralAttachment";
import { helper } from "@/packages/dashboard/utils";

export default {
  name: "ExamDeferralCard",
  components: { DeferralAttachment },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Deferral/studentProgramme");
      if (v.$route.params.code) {
        v.$store.dispatch("Deferral/getExamDeferral", v.$route.params.code);
      }
    });
  },
  data: () => ({
    isValid: true,
    displayAttachment: {},
    attachments: [],
    defermentFeeDialogBox: false,
    formData: {
      attachmentAPI: [],
      studentNo: "",
      profileID: "",
      programme: "",
      stage: "",
      examDeferralLines: [],
    },
    headers: [
      { text: "#S/N", sortable: false, value: "ID" },
      { text: "Unit Code", sortable: false, value: "unit" },
      {
        text: "Paper",
        align: "start",
        sortable: false,
        value: "paper",
      },
      { text: "Stage", sortable: false, value: "stage" },
    ],
    headersLines: [
      { text: "Unit Code", sortable: false, value: "unit" },
      {
        text: "Unit Description",
        align: "start",
        sortable: false,
        value: "description",
      },
      { text: "amount", sortable: false, value: "amount" },
    ],
  }),
  created() {
    this.defermentFeeDialogBox = true;
  },
  computed: {
    isEdit() {
      return this.$route.params.code && this.formData.status === "Open";
    },
    isReadonly() {
      return this.$route.params.code && this.formData.status !== "Open";
    },
    programme() {
      return this.$store.getters["Deferral/deferralGetter"](
        "programmeRegistration",
      ).shift();
    },
    BtnCaption() {
      return this.attachments.length === 0
        ? "Upload Documents"
        : "Add Document";
    },
    bookedUnits() {
      return this.programme
        ? this.programme.studentunits.filter((item) => item.taken)
        : [];
    },
    deferral() {
      return this.$store.getters["Deferral/deferralGetter"]("deferral");
    },
  },
  methods: {
    setAttachmentDialog(val) {
      this.$store.dispatch("Deferral/setAttachmentDialog", val);
    },
    editAttachment(val, index) {
      val.index = index;
      this.displayAttachment = val;
      this.setAttachmentDialog(true);
    },
    removeAttachment(index, item) {
      if (item.lineNo) {
        // delete exemption line
        this.$confirm.show({
          title: `Delete Deferral Attachment ${item.lineNo}?`,
          text: "Are you sure you want to delete this deferral Attachment, this action is irreversible",
          onConfirm: () => {
            this.$store.dispatch("Deferral/deleteAttachment", { ...item });
          },
        });
      } else {
        this.attachments.splice(index, 1);
      }
    },
    async addAttachment(file) {
      this.displayAttachment = {};
      if (file.index !== undefined) {
        Object.assign(this.attachments[file.index], file);
        delete this.attachments[file.index].index;
      } else {
        delete file.index;
        this.attachments.push(file);
      }
    },
    UpdateDeferral() {
      if (!this.isValid) {
        this.$refs.deferralForm.validate();
      } else if (this.attachments.length === 0) {
        Event.$emit(
          "ApiError",
          "Minimum of two documents(Deferral Letter and Reason) is required to proceed!",
        );
      } else {
        const data = { ...this.formData };
        data.attachmentAPI = [];
        Array.prototype.push.apply(data.attachmentAPI, this.attachments);
        delete data.examDeferralLines;
        this.$store.dispatch("Deferral/patchDeferral", {
          ...data,
        });
      }
    },
    requestForDeferral() {
      this.submitting = true;
      if (!this.isValid) {
        this.$refs.deferralForm.validate();
        this.submitting = false;
      } else if (this.attachments.length === 0) {
        Event.$emit(
          "ApiError",
          "Minimum of two documents(Deferral Letter and Reason) is required to proceed!",
        );
      } else {
        const data = { ...this.formData };
        Array.prototype.push.apply(data.attachmentAPI, this.attachments);
        delete data.examDeferralLines;
        this.$store.dispatch("Deferral/examDeferral", {
          ...data,
        });
      }
    },
    // set deferment fee dialog
    setDefermentFeeModal: function (value) {
      this.defermentFeeDialogBox = value;
    },
    closeDefermentFeeDialog() {
      this.defermentFeeDialogBox = false;
    },
  },
  watch: {
    programme() {
      const { programme, intakeStage, profileID, studentNo } = this.programme;
      this.formData.programme = programme;
      this.formData.stage = intakeStage;
      this.formData.profileID = profileID;
      this.formData.studentNo = studentNo;
    },
    deferral: {
      handler: function (data) {
        const attachments = data.attachmentAPI;
        delete data.attachmentAPI;
        this.formData = { ...data };
        const base64Attachments = [];
        attachments.map(async (el) => {
          const blob = await helper.getFileBlob(
            process.env.VUE_APP_TEMP_URL + el.base64Attachment,
            el.documentNo,
          );
          const base64 = await helper.toBase64(blob);
          base64Attachments.push({
            base64Attachment: base64.split(",")[1],
            fileName: `${blob.name}${el.lineNo}.${blob.type.split("/")[1]}`,
            comment: el.comment,
            blob,
            lineNo: el.lineNo,
            documentNo: el.documentNo,
            documentType: el.documentType,
          });
        });
        this.attachments = base64Attachments;
      },
    },
  },
};
</script>

<style scoped>
.deferral {
  font-family: "PT Sans Caption", sans-serif;
}
.attachment--documents {
  border-radius: 4px;
  padding: 1% 0 1% 0;
  border: 3px dashed green;
  background: #388e3c17;
}
@media all and (max-width: 480px) {
  .custom-class {
    width: 100%;
    display: block;
    margin-top: 0px;
  }
  .col1 {
    order: 2;
  }
  .col2 {
    order: 1;
  }
}
</style>
